'use strict';

import breakpoints from '../ui/breakpoints';
import NavigationActions from './common-navigation-actions';
import { Toggle } from '../ui/toggle';
import '../complib/polyfillClosest';

let Config = global.__NavigationConfig;
let State = global.__NavigationState;

/**
 * Update states.
 */
function updateGlobals() {
	Config = global.__NavigationConfig;
	State = global.__NavigationState;
}

/**
 * Add navigation click listeners.
 */
function addClickListeners() {
	const navigationSelectors = document.querySelectorAll('.js-select-navigation-container, .o-navigation__logo-container');
	for (const navigationSelector of navigationSelectors) {
		navigationSelector.addEventListener('click', (e) => {
			const target = e.target;
			e.preventDefault();

			if (target.dataset.navigation) {

				if (target.dataset.isMobile === 'true') {
					const navContainer = document.querySelector('.o-navigation__mobile .o-navigation__mobile-navigation');
					if (navContainer) {
						navContainer.classList.add('o-navigation__mobile-navigation--reveal');
					}

					NavigationActions.selectNavigation(target.dataset.navigation, true, () => {
						setTimeout(() => {
							NavigationActions.renderMobileNavigation();
							if (navContainer) {
								navContainer.classList.remove('o-navigation__mobile-navigation--reveal');
							}
							NavigationActions.updateNavigationFocusableElements();
						}, NavigationActions.getTransitionDuration(navContainer, 'opacity', '0.3s'));

					});
				} else {
					if (!target.classList.contains('a-navigation-toggle--selected')) {
						NavigationActions.selectNavigation(target.dataset.navigation);
					}

					if (target.getAttribute('href')) {
						location.assign(target.href);
					}

					if(target.classList.contains('a-navigation-logo')) {
						NavigationActions.deleteNavigationState();
						location.assign('/fi/');
					}

				}

			}

		});
	}

	const navigationBarDesktop = document.querySelector('.m-navigations');
	if (navigationBarDesktop) {
		navigationBarDesktop.addEventListener('click', (e) => {

			const target = e.target;


			if (target.classList.contains('js-dropdown-navigation-control')) {
				// Makes sure that only mouse triggers.
				if (e.detail !== 0) {
					e.preventDefault();
					NavigationActions.toggleDropdown(target);
					return;
				}
			}

			if (target.dataset.navigation && (target.dataset.silentNavigationSelect === 'true')) {
				NavigationActions.saveNavigationState({ navigation: target.dataset.navigation });
				return;
			}

		});
	}

	const mobileNav = document.querySelector('.o-navigation__mobile');
	if (mobileNav) {
		mobileNav.addEventListener('click', mobileNavigationClickHandler);
	}


	const menuButtons = document.querySelectorAll('.js-navigation-toggle');
	for (const menuButton of menuButtons) {
		menuButton.addEventListener('click', (e) => {
			const target = e.target.closest('.js-navigation-toggle');

			if (target) {

				if (target.classList.contains('a-toggle--active')) {
					NavigationActions.closeMobileNavigation();
				} else {
					NavigationActions.openMobileNavigation();
					NavigationActions.toggleMobileNavigationMenuButtonsStates();
				}
			}
		});
	}

	const collapsibleSections = document.querySelectorAll('.a-navigation-title--toggle');
	for (const collapsibleSection of collapsibleSections) {
		collapsibleSection.addEventListener('click', (e) => {
			const target = e.target;
			if (target) {
				NavigationActions.toggleCollapsibleSection(target);
			}
		});
	}
}

/**
 * Add key listeners.
 */
function addKeyListeners() {
	const navigationBarDesktop = document.querySelector('.m-navigations');

	if (navigationBarDesktop) {

		// Prevents scrolling when pressing space.
		navigationBarDesktop.addEventListener('keydown', (e) => {

			const handleAction = (e) => {
				const navDropdownItem = e.target;
				if (['BUTTON', 'A'].includes(navDropdownItem.tagName)) {
					e.preventDefault();
				}
			};

			switch (e.key) {
				case ' ':
					handleAction(e);
					return;
			}

		});

		navigationBarDesktop.addEventListener('keydown', (e) => {

			const handleEsc = (e) => {
				e.preventDefault();
				NavigationActions.closeAllDropdownNavigations(true);
			};

			const handleAction = (e) => {

				const navDropdownItem = e.target;

				if (navDropdownItem.classList.contains('js-dropdown-navigation-control')) {
					e.preventDefault();
					if (navDropdownItem.classList.contains('a-navigation-item--open')) {
						NavigationActions.closeAllDropdownNavigations(true);
					} else {
						NavigationActions.openDropdownNavigation(navDropdownItem);
					}
				}

			};

			switch (e.key) {
				case 'Enter':
				case ' ':
					handleAction(e);
					return;
				case 'Escape':
				case 'Backspace':
					handleEsc(e);
					return;
			}

		});

	}

	const desktopActions = document.querySelector('.js-navigation-actions-desktop');
	if (desktopActions) {
		desktopActions.addEventListener('keydown', (e) => {
			const button = e.target;
			if (button.classList.contains('js-navigation-toggle')) {
				switch (e.key) {
					case ' ':
					case 'Enter':
						setTimeout(() => { NavigationActions.focusMobileNavigationListElement(false, true) }, NavigationActions.getTransitionDuration(document.querySelector('o-navigation__mobile'), 'transform', '0.3s') + 50);
						return;
				}
			}
		});
	}

	const clubNav = document.querySelector('.js-club-nav-toggle');
	if (clubNav) {
		new Toggle(clubNav, {
			activeClass: 'm-navigation-actions__dropdown--open',
			toggleOnHover: true,
			useBreakpoints: true,
			enabledBreakpoints: ['desktop'],
			autoClose: true
		});
	}
}

/**
 * Add mouse listeners.
 */
function addMouseListeners() {
	const dropdownMenuItems = document.querySelectorAll('.js-dropdown-navigation-control');
	const dowdownNavigations = document.querySelectorAll('.js-dropdown-navigation');

	for (const dowdownNavigation of dowdownNavigations) {
		dowdownNavigation.addEventListener('mouseenter', (e) => {
			if (State.timer) {
				clearTimeout(State.timer);
			}
		});

		dowdownNavigation.addEventListener('mouseleave', (e) => {

			if (State.timer) {
				clearTimeout(State.timer);
			}
			State.timer = setTimeout(() => {
				const navDropdownItem = e.target;
				const parentListElement = navDropdownItem.closest('.a-navigation-bar-item');
				if (parentListElement) {
					NavigationActions.closeAllDropdownNavigations();
				}
			}, Config.navigationCloseAfter);
		});
	}


	for (const dropdownMenuItem of dropdownMenuItems) {
		dropdownMenuItem.addEventListener('mouseenter', (e) => {

			if (State.timer) {
				clearTimeout(State.timer);
			}
			State.timer = setTimeout(() => {
				NavigationActions.openDropdownNavigation(e.target);
			}, Config.navigationHoverDealy);

		});

		dropdownMenuItem.addEventListener('mouseleave', (e) => {

			if (State.timer) {
				clearTimeout(State.timer);
			}
			State.timer = setTimeout(() => {
				NavigationActions.closeAllDropdownNavigations();
			}, Config.navigationCloseAfter);
		});
	}

}

/**
 * Update header navigation state based on breakpoint
 *
 * @param {String} breakpoint - precise ui breakpoint name
 * @param {HTMLElement} mainHeader - header element
 */
function updateHeaderState(breakpoint, mainHeader) {
	if (breakpoint === 'small' || breakpoint === 'medium' || breakpoint === 'large') {
		// Update sticky limit based on breakpoin
		State.stickyLimit = breakpoint === 'small' ? 140 : 76;

		// Enable sticky nav if not already
		if (!State.isStickyNav) {
			State.isStickyNav = true;
			mainHeader.classList.add('o-header--mobile');
			updateHeader(mainHeader);
		}
	} else {
		// Disable sticky nav
		State.isStickyNav = false;
		mainHeader.classList.remove('o-header--mobile', 'o-header--transform', 'o-header--pull-down', 'o-header--sticky', 'o-header--hide-content');
	}
}

/**
 * Update header navigation classes and state
 *
 * @param {HTMLElement} mainHeader - header element
 */
function updateHeader(mainHeader) {
	const currentScrollPosition = window.scrollY;
	if (State.previousScrollPosition === undefined) {
		State.previousScrollPosition = window.scrollY;
	}

	const directionUp = State.previousScrollPosition > currentScrollPosition;
	if (currentScrollPosition < State.stickyLimit) {
		mainHeader.classList.remove('o-header--sticky', 'o-header--transform');
	} else {
		mainHeader.classList.add('o-header--sticky');
		setTimeout(() => {
			mainHeader.classList.add('o-header--transform');
		}, 300);

		if (directionUp) {
			mainHeader.classList.add('o-header--pull-down');
		} else {
			mainHeader.classList.add('o-header--hide-content');
		}
	}

	if (directionUp) {
		mainHeader.classList.remove('o-header--hide-content');
	} else {
		mainHeader.classList.remove('o-header--pull-down');
	}

	State.previousScrollPosition = currentScrollPosition;
}

/**
 * Add scroll listener (used for header autohide when mobile).
 */
function addScrollListeners() {
	const mainHeader = document.querySelector('.o-header');
	if (mainHeader) {
		// Set main header states based on breakpoint
		updateHeaderState(breakpoints.getBreakpoint('precise'), mainHeader);
		breakpoints.addChangeSubscriber((breakpoint) => {
			updateHeaderState(breakpoint, mainHeader);
		}, 'precise');

		setTimeout(() => {
			document.addEventListener('scroll', () => {
				if (State.menuTransitioning) {
					return;
				}
				if (State.isStickyNav) {
					NavigationActions.debounceThrottle(() => {

						if (State.menuTransitioning) {
							return;
						}

						updateHeader(mainHeader);

					}, 200, 'navPullThrottle');
				}

			}, { passive: true });
		}, 500);
	}
}

/**
 * Handles mobile navigation key navigation.
 *
 * @param {Event} e - Key down evet.
 */
function mobileNavigationKeyHandler(e) {

	const element = e.target;
	const isBackButton = element.classList.contains('mobile-menu-category-parent-button');
	if (((element.dataset.hasChildren === 'true') || isBackButton) && [' ', 'Enter'].includes(e.key)) {

		if (element.dataset.hasChildren === 'true') {
			State.previousClickedElement = element;
		}

		setTimeout(() => { NavigationActions.focusMobileNavigationListElement(isBackButton) }, NavigationActions.getTransitionDuration(document.querySelector('.o-navigation__mobile-navigation'), 'transform', '0.3s') + 50);
		return;
	}
	switch (e.key) {
		case 'Backspace':
			e.preventDefault();
			NavigationActions.goBackMobileNavigationLevel(true);
			return;
		case 'Esc':
		case 'Escape':
			e.preventDefault();
			NavigationActions.closeMobileNavigation();
			return;
	}
}


/**
 * Handles resize event.
 */
function mobileResizeHandler() {
	NavigationActions.debounceThrottle(() => {
		const mobileNavigationContainer = document.querySelector('.o-navigation__mobile');
		if (mobileNavigationContainer) {
			if (mobileNavigationContainer.classList.contains('o-navigation__mobile--onscreen') && getComputedStyle(mobileNavigationContainer).display === 'none') {
				NavigationActions.closeMobileNavigation();
			} else {
				NavigationActions.updateNavigationFocusableElements();
			}
		}
	}, 500, 'navResizeHelpers');
}

/**
 * Handle mobile navigation clicks.
 *
 * @param {Event} e - Click event.
 * @returns {boolean} True if click caused action, false if not.
 */
function mobileNavigationClickHandler(e) {
	const element = e.target;

	const navBack = element.closest('.a-navigation-list-item--navigate-back');
	if (navBack) {
		e.preventDefault();
		if (e.detail === 0) {
			// Keyboard
			NavigationActions.goBackMobileNavigationLevel(true);
		} else {
			// Mouse
			NavigationActions.goBackMobileNavigationLevel();
		}
		return true;
	}

	const menuItem = element.closest('.a-navigation-list-item');

	if (menuItem && !menuItem.classList.contains('a-navigation-list-item--navigate-back') && ((menuItem.dataset.hasChildren === 'true') || menuItem.dataset.navigation)) {
		if (menuItem.dataset.navigation && (menuItem.dataset.silentNavigationSelect === 'false')) {

			const navigationSelector = document.querySelector('.o-navigation__mobile .m-target-group-selector-mobile');
			if (navigationSelector) {
				navigationSelector.classList.add('m-target-group-selector-mobile--reveal');
			}

			const navContainer = document.querySelector('.o-navigation__mobile .o-navigation__mobile-navigation');
			if (navContainer) {
				navContainer.classList.add('o-navigation__mobile-navigation--reveal');
			}

			NavigationActions.selectNavigation(menuItem.dataset.navigation, true, () => {
				setTimeout(() => {
					if (navigationSelector) {
						if (navigationSelector.classList.contains('m-target-group-selector-mobile')) {
							navigationSelector.classList.remove('m-target-group-selector-mobile--hidden');
							requestAnimationFrame(() => {
								navigationSelector.classList.remove('m-target-group-selector-mobile--reveal');
							});
						}
					}
					NavigationActions.renderMobileNavigation();
					if (navContainer) {
						navContainer.classList.remove('o-navigation__mobile-navigation--reveal');
					}
					NavigationActions.updateNavigationFocusableElements();

					if (e.detail === 0) {
						// Keyboard
						NavigationActions.focusMobileNavigationListElement();
					}

				}, NavigationActions.getTransitionDuration(navContainer, 'opacity', '0.3s'));

			}, true);
			return true;
		} else if (menuItem.dataset.navigation && (menuItem.dataset.silentNavigationSelect === 'true')) {
			NavigationActions.saveNavigationState({ navigation: menuItem.dataset.navigation });
		}

		const menuItemData = State.navigationLookup['nav-item-' + menuItem.dataset.navItemId];

		if (menuItemData && Array.isArray(menuItemData.children) && menuItemData.children.length) {

			NavigationActions.renderMobileNavigationLevel(menuItemData.children, menuItem);
		}
		return true;
	}

	if (menuItem && (menuItem.dataset.hasChildren === 'false') && menuItem.href) {

		//location.assign(menuItem.href);
		return true;
	}

	return false;
}


/**
 * Handles mobile navigation focus lock.
 *
 * @param {Event} e - Key down event.
 */
function mobileNavigationFocusLockHandler(e) {

	const handleTab = () => {

		const firstElement = State.allFocusableElements[0];
		const lastElement = State.allFocusableElements[State.allFocusableElements.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === firstElement) {
				if (lastElement) {
					e.preventDefault();
					lastElement.focus();
				}
			}
		} else {
			if (document.activeElement === lastElement) {
				if (firstElement) {
					e.preventDefault();
					firstElement.focus();
				}
			}
		}
	};

	const handleArrow = (up) => {
		let index = false;
		for (const [i, element] of State.allFocusableElements.entries()) {
			if (element === document.activeElement) {
				index = i;
				break;
			}
		}

		const firstElement = State.allFocusableElements[0];
		const lastElement = State.allFocusableElements[State.allFocusableElements.length - 1];

		if ((index === false) && firstElement) {
			firstElement.focus();
			return;
		}


		if (up) {
			if (index === 0) {
				e.preventDefault();
				lastElement.focus();
			} else {
				const previousElement = State.allFocusableElements[index - 1];
				if (previousElement) {
					previousElement.focus();
				} else if (lastElement) {
					lastElement.focus();
				}
			}

		} else {
			if (index === (State.allFocusableElements.lenght - 1)) {
				e.preventDefault();
				firstElement.focus();
			} else {
				const nextElement = State.allFocusableElements[index + 1];
				if (nextElement) {
					nextElement.focus();
				} else if (firstElement) {
					firstElement.focus();
				}
			}
		}
	}

	switch (e.key) {
		case 'Tab':
			handleTab();
			break;
		case 'ArrowDown':
		case 'ArrowRight':
			e.preventDefault();
			handleArrow();
			break;
		case 'ArrowUp':
		case 'ArrowLeft':
			e.preventDefault();
			handleArrow(true);
			break;
	}

}


/**
 * Handles popstate (i.e. when user navigates back using back button).
 */
function handlePopstate() {
	NavigationActions.goBackMobileNavigationLevel();
}

/**
 * Add mobile navigation listeners.
 */
function addMobileNavigationListeners() {
	if (!State.hasMobileNavKeyListener) {
		window.addEventListener('resize', mobileResizeHandler, { passive: true });
		window.addEventListener('popstate', handlePopstate);
		document.addEventListener('keydown', mobileNavigationKeyHandler);
		document.addEventListener('keydown', mobileNavigationFocusLockHandler);
		State.hasMobileNavKeyListener = true;
	}
}

/**
 * Remove mobile navigation listeners.
 */
function removeMobileNavigationListeners() {
	if (State.hasMobileNavKeyListener) {
		window.removeEventListener('resize', mobileResizeHandler, { passive: true });
		window.removeEventListener('popstate', handlePopstate);
		document.removeEventListener('keydown', mobileNavigationKeyHandler);
		document.removeEventListener('keydown', mobileNavigationFocusLockHandler);
		State.hasMobileNavKeyListener = false;
	}
}


export default { addClickListeners, addMouseListeners, addKeyListeners, addScrollListeners, mobileResizeListener: mobileResizeHandler, addMobileNavigationListeners, removeMobileNavigationListeners, updateGlobals };
